import { connect } from "react-redux";
import ProjectEditorPanel from "./projectEditorPanel";
import actionCreators from "./redux/actionCreators";
import { getData, getInProgress, getProjectId } from "./redux/selectors";
const mapStateToProps = (state) => ({
    inProgress: getInProgress(state),
    data: getData(state),
    projectId: getProjectId(state)
});
const mapDispatchToProps = (dispatch) => ({
    onInitialized: (projectId) => dispatch(actionCreators.getProject(projectId)),
    onClose: () => dispatch(actionCreators.setProjectId(undefined))
});
export default connect(mapStateToProps, mapDispatchToProps)(ProjectEditorPanel);
